import { api } from "./AxiosInstance";

export const GetAllEmployeesApi = async (
  page,
  isActive,
  employeeId,
  employeeName,
  exportData,
  type
) =>
  await api.get(
    `/employee-connect/employee/admin?type=${
      type ? type : "existing"
    }&page_num=${page}&page_size=10&is_active=${isActive}&employee_id=${employeeId}&name=${employeeName}&export=${
      exportData ? true : false
    }`
  );

export const DeleteEmployeeApi = async (id) =>
  await api.delete(`/employee-connect/employee/admin/${id}`);

export const AddEmployeeApi = async (val, type) =>
  await api.post(
    `employee-connect/employee/admin?type=${
      type === true ? "new" : "existing"
    }`,
    {
      name: {
        first_name: val.firstName,
        middle_name: val.middleName,
        last_name: val.lastName,
      },
      employee_id: val.employeeId ? val.employeeId : "",
      job_role: val.role ? val.role : "",
      gender: val.gender,
      title: val.title,
      blood_group: val.bloodGroup,
      emergency_contact: val.emergencyContact,
      mobile: val.mobile,
      personal_email: val.personalEmail,
      company_email: val.companyEmail,
      date_of_birth: val.dob,
      date_of_joining: val.doj,
      reporting_manager_id: val.managerId,
      company: val.company,
      business_unit: val.businessUnit,
      function: val.function,
      corporate: val.corporate,
      office: val.office,
      designation: val.designation,
      aadhar_card_number: val.aadharNumber,
      pan_card_number: val.panNumber,
      interview: {
        interview_date: val.interviewDate,
        interviewer: val.interviewer,
      },
    }
  );

export const UpdateEmployeeApi = async (id, val) =>
  api.post(`/employee-connect/employee/admin/${id}`, {
    name: {
      first_name: val.firstName,
      middle_name: val.middleName,
      last_name: val.lastName,
    },
    job_role: val.role ? val.role : "",

    employee_id: val.employeeId ? val.employeeId : "",
    company_email: val.companyEmail,

    gender: val.gender,
    title: val.title,
    mobile: val.mobile,
    blood_group: val.bloodGroup,
    emergency_contact: val.emergencyContact,
    date_of_birth: val.dob,
    date_of_joining: val.doj,
    reporting_manager_id: val.managerId,
    company: val.company,
    business_unit: val.businessUnit,
    function: val.function,
    corporate: val.corporate,
    office: val.office,
    designation: val.designation,
    is_active: val.isActive,
    aadhar: val.aadharNumber,
    pan: val.panNumber,
    interview: {
      interview_date: val.interviewDate,
      interviewer: val.interviewer,
    },
  });

export const ExcelUploadApi = async (formData, type) =>
  api.post(
    `/employee-connect/employee/admin/excel?type=${
      type === true ? "new" : "existing"
    }`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

export const ImageUploadApi = async (formData, empId) =>
  api.post(
    `/employee-connect/employee/upload_image?employee_id=${empId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

export const GetEmpIdCardApi = async (employeeId) =>
  await api.post(
    `/employee-connect/employee/downloads?employee_id=${employeeId}`
  );

export const GetAllMediclaimApi = async () =>
  await api.get(`/employee-connect/mediclaim/report?export=true`);

export const VerifyPanAPI = async (pan, id) =>
  await api.post(`employee-connect/employee/pan_card_validation`, {
    pan_card: pan,
    _id: id,
  });

export const GetOtpAPI = async (data) =>
  await api.post(`employee-connect/employee/ad_otp`, {
    aadhar_num: data.aadhar_num,
    _id: data?._id,
    mobile: data?.mobile,
  });

export const VerifyOtpAPI = async (aadhaarRes, inputData, otp) =>
  await api.post(`employee-connect/employee/ad_verify`, {
    client_id: aadhaarRes?.client_id,
    aadhar_num: inputData?.aadhar_num,
    mobile_number: inputData?.mobile,
    otp: otp,
    _id: inputData?._id,
  });

export const ApiKycSubmit = async (inputData) => {
  console.log("kyc data", inputData);
  return await api.post(`/employee-connect/employee/kyc_verifed`, {
    _id: inputData._id,
    pan_verified: inputData?.pan_verified,
    aadhar_verified: inputData?.aadhar_verified,
    aadhar_deviation: inputData?.aadhar_deviation,
    pan_deviation: inputData?.pan_deviation,
  });
};

export const ApiChangeStatus = async (
  id,
  status,
  reason = "",
  employee_id = "",
  company_email = ""
) =>
  await api.post("/employee-connect/employee/status-changes", {
    _id: id,
    status: status,
    reason: reason,
    employee_id: employee_id,
    company_email: company_email,
  });

export const BulkStatusApi = async (formData) =>
  api.post(`/employee-connect/employee/bulk-status-changes`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const GenerateDocsAPI = async (id) =>
  api.post(`/employee-connect/employee/generate-all-forms/${id}`);
